/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2019 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../../core/IceEntity';
import { IceTypes } from '../../icetypes';
import { observation } from 'projects/icemedx-lib/src/models/ehr/subs/observation';
import { diagnosisreference } from 'projects/icemedx-lib/src/models/ehr/subs/diagnosisreference';
import { provider_reference } from '../../domain/provider_reference';
import { procedure } from './procedure';
import { subtypereference } from './subtypereference';
import { alert } from '../../system/alert';

export class managementguideline extends IceEntity {
	management_guideline_key: string = "";
  title: string = "";
  management_guideline_type = IceTypes.guidelinetype.gdetypePreventive;
  src_type: number = 0;
  src_key: string = "";
  sub_type: number = 0;
  disabled: boolean = false;
  alert_type: IceTypes.ALERTTYPE = IceTypes.ALERTTYPE.alertAdverseInteraction;
  age_range_start: number = 0.0;
  age_range_end: number = 0.0;
  age_unit_type: number = 0;
  patient_weight_range_start: number = 0.0;
  patient_weight_range_end: number = 0.0;
  patient_weight_unit_code: string = "";
  sex: string = "";
  description: string = "";
  high_limit: number = 0.0;
  low_limit: number = 0.0;
  record_version: number = 0;
  offline_record_status: number = 0;
  accessed: any = NaN;
  accessed_user: string = "";
  created: any = NaN;
  created_user: string = "";
  modified: any = NaN;
  modified_user: string = "";

  // Activity Fields
  activity_type: IceTypes.activitytype = IceTypes.activitytype.atRender;
  activity_date: any = NaN;
  activity_note: string = "";
  indication: string = "";
  completion_status: string = "";
  action_code: string = "";
  administered_code: string = "";
  administered_amount: number = 0.0;
  administered_units: string = "";
  administration_notes_code: string = "";
  administered_per_time: number = 0;
  administered_per_time_unit: string = "";
  site_cfield_data: string = "";
  site: string = "";
  sig: string = "";
  department_key: string = "";
  activity_description: string = "";

  // Order Fields
  order_entry_key: string = "";
  order_entry_date: any = NaN;
  order_status_type: IceTypes.orderentrystatus = IceTypes.orderentrystatus.oestatusWaiting;
  order_status_note: string = "";
  signature: string = "";
  signature_date: any = NaN;
  manufacturer_product_key: string = "";
  order_note: string = "";
  message_key: string = "";
  agent_first_name: string = "";
  agent_last_name: string = "";
  orc1_order_control: string = "";
  orc2_placer_order_number: string = "";
  orc3_filler_order_number: string = "";
  orc4_placer_group_number: string = "";
  orc5_order_status: string = "";
  orc6_response_flag: string = "";
  orc12_ordering_provider: string = "";
  obr4_universal_service_identifier: string = "";
  obr7_observation_datetime: any = NaN;
  obr8_observation_end_datetime: any = NaN;
  obr11_specimen_action_code: string = "";
  obr16_ordering_provider: string = "";
  obr22_results_rptstatus_chng_datetime: any = NaN;
  obr25_result_status: string = "";

  // Referral
  referral_from_key: string = "";
  trans_account: string = "";
  requester_trans_account: string = "";
  requester_account_type: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
  subscriber_key: string = "";

  DIAGS: diagnosisreference[] = [];
  OBSERVS: observation[] = [];
  PROS: provider_reference[] = [];
  PROCSRS: procedure[] = [];
  SUBTYPES: subtypereference[] = [];
  ALERTS: alert[] = [];

  gettablename(): string {
    return "MANAGEMENT_GUIDELINE";
  }

  hassubtree(ColumnName): boolean {
    if (ColumnName.Length == 0) return false;
    else if (ColumnName == "DIAGS") return true;
    else if (ColumnName == "OBSERVS") return true;
    else if (ColumnName == "PROS") return true;
    else if (ColumnName == "PROCSRS") return true;
    else if (ColumnName == "SUBTYPES") return true;
    else if (ColumnName == "ALERTS") return true;

    return false;
  }

  getsubtreetablename(ColumnName): string {
    if (ColumnName.Length == 0) return null;
    else if (ColumnName == "DIAGS") return "DIAGNOSIS_REFERENCE";
    else if (ColumnName == "OBSERVS") return "OBSERVATION";
    else if (ColumnName == "PROS") return "PROVIDER_REFERENCE";
    else if (ColumnName == "PROCSRS") return "PROCEDURE";
    else if (ColumnName == "SUBTYPES") return "SUB_TYPE_REFERENCE";
    else if (ColumnName == "ALERTS") return "ALERT";

    return null;
  }
}
